let EnvironmentService = {
    isProduction() {
        return !window.location.host.includes('develop') && !window.location.host.includes('localhost');
    },

    staticURL() {
        return `${EnvironmentService.baseURL()}/static`;
    },

    baseURL() {
        return (window.location.host.includes('localhost')) ? `https://develop.openswap.io` : `https://${window.location.host}`;
    },

    blockChainInfoURL() {
        return (window.location.host.includes('localhost') || window.location.host.includes('develop')) ? 'https://api.blockcypher.com/v1/btc/test3' : 'https://api.blockcypher.com/v1/btc/main';
    },

    chatAttachmentsBucket() {
        return EnvironmentService.isProduction()
            ? 'chat-attachments-009a-production'
            : 'chat-attachments-009a-develop';
    },
};

export default EnvironmentService
